var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-select-service-controller"},_vm._l((_vm.items),function(item){return _c('link-select-service',{key:item,ref:"services",refInFor:true})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }